import React, { useState, useEffect, useRef} from 'react';
import { v4 as uuidv4 } from 'uuid'
import "./Compare.scss"
const Compare = (props) => {
  const container = useRef(null);

  useEffect(() => {
    if(container?.current?.offsetHeight && props.data.field_label === "Intervention") {
      let height = container.current.offsetHeight;
      props.api.forEachNode((rowNode, i) => {
        if(rowNode.rowIndex === props.node.rowIndex) {
          rowNode.setRowHeight(height)
          props.api.onRowHeightChanged()
        }
      })
    }
  }, [container])

  const getFormatInterventions = (interventions) => {
    return interventions.map((int, i) => {
      return (
        <div key={uuidv4()} className='registry-interventions'>
          <div className='intervention-title'>{`${int.name}: ${int.type}`}</div>
          <div className='intervention-description'>{int.description}</div>
        </div>
      )
    })
  }

  const displayValue = () => {
    if(typeof props.value === 'object' && props.value !== null) {
      if(props.data.field_label === "Intervention") {
        return (
          <div className='registery-in-container'>
            {getFormatInterventions(props.value)}
          </div>
        )
      }
    } else {
      return props.value
    }
  }

  return (
    <div ref={container} className='compare-registery-container'>
      {displayValue()}
    </div>
  );
};

export default Compare;






